import { datadogLogs } from "@datadog/browser-logs";
import { DATADOG_TOKEN, ENVIRONMENT_TYPE } from "config/env";

export const initDatadog = () => {
    datadogLogs.init({
        clientToken: DATADOG_TOKEN,
        site: 'us3.datadoghq.com',
        service: 'te-website-ui',
        env: ENVIRONMENT_TYPE,
        forwardErrorsToLogs: true,
        sessionSampleRate: 100,

        beforeSend: function (log) {
            var msg = '';
            if (log && log.message) {
              msg = log.message;
            } else if (log && log.error && log.error.message) {
              msg = log.error.message;
            } else if (log && log.error && log.error.stack) {
              msg = log.error.stack;
            }
        
            if (
              msg &&
              (
                msg.indexOf('Warning:') === 0 ||
                msg.indexOf('unique "key" prop') !== -1
              )
            ) {
              return false;
            }
        }
    })
}